<template>
  <div>
    <el-card style="text-align: center;">
      起止时间：<el-date-picker
      v-model="time1"
      type="date"
      @change="getStartDate()"
      format="yyyy-MM-dd"
      placeholder="选择日期"
    ></el-date-picker>
      ——
      <el-date-picker
        v-model="time2"
        type="date"
        @change="getEndDate()"
        format="yyyy-MM-dd"
        placeholder="选择日期"
        style="margin-right: 2%"
      ></el-date-picker>
      订单状态：
      <el-select class="form-control" style="width: 200px ;margin-right: 20px" v-model="to_state">
        <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"  >{{item.label,item.value}}</el-option>
      </el-select>
      关键字：
      <el-input style="width: 15%;margin-right: 2%" type="text" placeholder="客户号/运单编号" v-model="accountNumber" />
      <el-button icon="el-icon-search" type="success" @click="selectRowOrder">搜索</el-button>
    </el-card>
    <el-table :data="order" class="tb-edit" style="width: 80%;margin: 20px auto;">
      <el-table-column type="select" min-width="5%"></el-table-column>
      <el-table-column prop="to_orderNumber" label="运单编号" min-width="18%">
      </el-table-column>
      <el-table-column prop="to_account" label="客户号" min-width="12%">
      </el-table-column>
      <el-table-column prop="to_picture" label="物品图片" min-width="25%">
      </el-table-column>
      <el-table-column prop="to_state" label="订单状态" min-width="12%">
        <template slot-scope="scope">
          <p v-if="scope.row.to_state == 0" style="color: red">未发货</p>
          <p v-else-if="scope.row.to_state == 1" style="color: blue">已发货</p>
          <p v-else style="color: green">已收货</p>
        </template>
      </el-table-column>
      <el-table-column prop="to_outTime" label="下单时间" min-width="20%">
        <template slot-scope="scope">
          {{scope.row.to_outTime | moment0}}
        </template>
      </el-table-column>
      <el-table-column prop="to_endTime" label="收货时间" min-width="20%">
          <template slot-scope="scope">
            <p v-if="scope.row.to_endTime == null"></p>
            <p v-else>{{scope.row.to_endTime | moment0}}</p>
        </template>
      </el-table-column>
      <el-table-column  label="操作" min-width="31%" >
        <template slot-scope="scope">
          <el-button icon="el-icon-circle-check" size="small" type="primary"
                     @click="updateUser(scope.row.to_orderNumber,)"
                      v-if="scope.row.to_state==0">确定发货</el-button>
          <el-button icon="el-icon-edit" size="small" type="primary"
                     @click="updateOrder(scope.row.to_orderNumber,scope.row.to_account,scope.row.to_picture,scope.row.to_remark,)" style="float: right;margin-right: 60px">订单编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <!--分页组件-->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
    export default {
      inject:['reload'],
      data(){
        return {
          options:[
            {label:'请选择',value:null},
            {label:'未发货',value:0},
            {label:'已发货',value:1},
            {label:'已收货',value:2}
          ],
          order: [],
          time1:null,
          time2:null,
          to_state:null,
          accountNumber:'',
          to_remark:'',
          currentPage: 1,
          pageSize: 20,
          total: 0,
        }
      },
      mounted() {

        this.to_account=this.$route.query.ta_account
        this.getOrder();
      },

      methods: {
        //获取订单信息
        getOrder(){
          this.$inbound.post({
            interfaceId: 'order/selectRowOrder',
            data:{
              accountNumber:this.to_account
            }
          }).then(response => {
            this.order=response
          }).catch(error => {
            this.$message.error('没有对应的订单信息');
          })
        },
        //根据条件查询订单信息
        selectRowOrder(){
          this.$inbound.post({
            interfaceId: 'order/selectRowOrder',
            data:{
              time1:this.time1,
              time2:this.time2,
              to_state:this.to_state,
              accountNumber:this.accountNumber,
            }
          }).then(response => {
            // console.log(response)
            this.order=response
          }).catch(error => {
            console.log(error)
            this.$message.error('没有查询到信息');
          })
        },
        //编辑订单信息
        updateOrder(to_orderNumber,to_account,to_picture,to_remark){
          this.$router.push({
            path: '/updateUserOrder',
            query: {
              to_orderNumber: to_orderNumber,
              to_account: to_account,
              to_picture: to_picture,
              to_remark: to_remark,
            }
          })

        },
        updateUser(id){
          this.$inbound.post({
            interfaceId: 'order/updateOrder',
            data: {
              to_orderNumber: id,
              to_state:1
            }
          }).then(response => {
            window.location.reload()
          }).catch(error => {
            console.log(error)
          })
          },
        //获取开始时间
        getStartDate() {
          const d = new Date(this.time1);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.time1 = year + '-' + month + '-' + day;
        },
        //获取结束时间
        getEndDate() {
          const d = new Date(this.time2);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.time2 = year + '-' + month + '-' + day;
        },
        },



    }
</script>

<style scoped>

</style>
